import rnCore from 'rhino/src/core/core.module';
import rnPreferences from 'rhino/src/components/preferences/preferences.module';
import rnLocaleFormat from './format/format.module';

import * as rnLocaleCookie from './locale-cookie.provider';
import * as rnLocale from './locale.service';

export default angular.module('rhino.components.locale', [
  'ngCookies',
  rnCore,
  rnPreferences,
  rnLocaleFormat
])
  .provider(rnLocaleCookie.name, rnLocaleCookie.default)
  .service(rnLocale.name, rnLocale.default)
  .name;
